import { AutocompleteProps as Mui5AutocompleteProps, default as Mui5Autocomplete } from '@mui/material/Autocomplete'
import { forwardRef } from 'react'
import { styled } from '../styles'
import { Icon } from './Icon'

const StyledLimitTagsText = styled('span')(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.neutralGrey[1300],
}))

export type AutocompleteProps = Mui5AutocompleteProps<
  any,
  boolean | undefined,
  boolean | undefined,
  boolean | undefined
>

export const Autocomplete = forwardRef<unknown, AutocompleteProps>((props, ref) => {
  return (
    <Mui5Autocomplete
      popupIcon={<Icon icon={'keyboard_arrow_down'} />}
      clearIcon={<Icon icon={'close_small'} />}
      getLimitTagsText={(limit) => <StyledLimitTagsText>{`+${limit} more`}</StyledLimitTagsText>}
      ref={ref}
      {...props}
    />
  )
})
